function attachRemoveEventListeners() {
  const removeButtons = document.querySelectorAll(".remove-swatch-button");

  removeButtons.forEach((btn) => {
    btn.addEventListener("click", async function (e) {
      e.preventDefault();

      const lineItemKey = btn.dataset.lineItemKey;
      const swatchToRemove = btn.dataset.removeValue;

      if (!lineItemKey || !swatchToRemove) return;

      // Fetch full cart
      const res = await fetch("/cart.js");
      const cart = await res.json();

      const allSwatchItems = cart.items.filter(
        (item) =>
          item.properties &&
          (item.properties._sample_type === "swatch" ||
            item.properties.sample_type === "swatch")
      );

      const variantId = allSwatchItems[0]?.variant_id;
      const remainingSwatches = [];

      // Collect all swatches except the one being removed
      for (const item of allSwatchItems) {
        Object.entries(item.properties).forEach(([key, value]) => {
          if (
            key.startsWith("Swatch Item ") &&
            value !== swatchToRemove
          ) {
            remainingSwatches.push(value);
          }
        });

        // Remove the original swatch line item
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
      }

      // Re-add chunks of remaining swatches in sets of 5
      for (let i = 0; i < remainingSwatches.length; i += 5) {
        const chunk = remainingSwatches.slice(i, i + 5);
        const properties = {
          _sample_type: "swatch",
          _swatch_count: chunk.length.toString(),
          "Sample Count": `${chunk.length} sample${chunk.length !== 1 ? "s" : ""}`,
        };

        chunk.forEach((swatch, index) => {
          properties[`Swatch Item ${index + 1}`] = swatch;
        });

        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties,
          }),
        });
      }

      // Live DOM cart refresh
      const response = await fetch("/cart");
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");

      const updatedCartList = doc.querySelector(".cartitems--list");
      const currentCartList = document.querySelector(".cartitems--list");

      if (updatedCartList && currentCartList) {
        currentCartList.innerHTML = updatedCartList.innerHTML;
        attachRemoveEventListeners(); // Rebind buttons
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", attachRemoveEventListeners);